































import { PropType, defineComponent, computed, getCurrentInstance } from '@vue/composition-api';
import { Message, IntentionBackQuestionData, IntentionBackQuestion } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import Card from './Card.vue';
import { useMessage } from '../../hooks/useMessage';
import { useMessageInteract } from '../../hooks/useMessageInteract';
export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<IntentionBackQuestionData>>,
      required: true
    }
  },
  setup(props) {
    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const { t } = useLocale();
    const instance = getCurrentInstance()?.proxy!;
    const { isDisabled } = useMessageInteract(props.message);
    const options = computed(() => {
      return props.message.content.questionList;
    });
    const intent = computed(() => {
      return props.message.content.intent;
    });
    const clickSendMessage = async (value: IntentionBackQuestion, event: Event) => {
      const msg = addUserTextMessage(value.title);
      robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'input', value.title, {
        event: event,
        intent: intent.value,
        parabolaAnimation: true
      }, {
        params: value.params,
        intent: intent.value
      }));
      instance.$track.send('WebIM_SendIntent', {
        Send_Type: '意图机器人问题',
        Intent_Type: props.message.content.intent,
        Intent_Keywords: value.recommend ? '用户上次使用的内容' : value.title
      }, true);
    };

    return {
      t,
      options,
      isDisabled,
      clickSendMessage
    };
  }
});
